import {
  getFoundationAllowedOrigins,
  parseOriginList,
} from "@web/lib/runtime/foundation-origins";
import { isDevelopmentRuntime } from "@web/lib/runtime/runtime-env";
import { createTrustedWebOriginPolicy } from "@garagem/foundation-shared/lib/auth/trusted-web-origin";
export { USERLAND_DEV_ORIGINS_ENV } from "@garagem/foundation-shared/lib/auth/trusted-web-origin";

export const {
  shareGaragemAuthCookies,
  buildBetterAuthTrustedOrigins,
  isTrustedWebOrigin,
  isTrustedOficinaOrigin,
  userlandWebReturnPath,
  isTrustedAdminOrigin,
  isTrustedWebReturnUrl,
  isTrustedAdminReturnUrl,
  webReturnBridgePath,
  shouldUseWebReturnBridge,
  shouldShowOperatorGoogleLogin,
} = createTrustedWebOriginPolicy({
  envSource: () => process.env,
  isDevelopmentRuntime,
  parseOriginList,
  getFoundationAllowedOrigins,
});
